export const ROLE_LABELS = {
  external_coordinator: 'External Coordinator',
  coordinator:          'Coordinator',
  project_leader:       'Project Leader',
  wp_leader:      'WP Leader',
  task_leader:    'Task Leader',
  researcher:     'Researcher',
  contributor:    'Contributor',
  reviewer:       'Reviewer',
  communicator:   'Communicator',
  other:          'Other',
};

// On a publication the project leader is the corresponding author
export const PUBLICATION_ROLE_LABELS = {
  project_leader: 'Corresponding Author',
};

/** Label for a role; pass { publication: true } for roles held on a publication. */
export const roleLabelFor = (role = '', { publication = false } = {}) =>
  (publication && PUBLICATION_ROLE_LABELS[role])
  || ROLE_LABELS[role]
  || role.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

// Display order in MemberCard (lower = shown first)
export const ROLE_ORDER = {
  external_coordinator: 0,
  coordinator:          1,
  project_leader:       2,
  wp_leader:      3,
  task_leader:    4,
  researcher:     5,
};

// Priority rank for role-conflict resolution and member list sorting (higher wins)
export const ROLE_RANK = {
  external_coordinator: 7,
  coordinator:          6,
  project_leader:       5,
  wp_leader:            4,
  task_leader:          3,
  researcher:           2,
  contributor:          1,
  reviewer:             1,
  communicator:         1,
  other:                0,
};

// Roles that render as filled chips with white text
export const WHITE_TEXT_ROLES = ['coordinator', 'external_coordinator', 'project_leader', 'wp_leader', 'task_leader'];

// Proposal-scoped hierarchy: ordered highest → lowest rank.
// When a member holds multiple of these, only the highest is shown in MemberCard.
// coordinator is intentionally excluded — it is consortium-level and always shown.
export const PROPOSAL_HIERARCHY = ['project_leader', 'wp_leader', 'task_leader', 'researcher'];

// ── Rank badge colors ─────────────────────────────────────────────────────────
// To remap a role's badge color, change the palette token on the right,
// or replace it with a literal hex string (e.g. '#10b981').
//
//   Role           Token                  Light-theme hex
//   ─────────────  ─────────────────────  ──────────────
//   coordinator    primary.main           #6366f1  (indigo)
//   project_leader secondary.main         #ad89ad  (mauve)
//   wp_leader      primary.light          #8693d3  (periwinkle)
//   task_leader    info.main              #0288d1  (sky blue)
//   researcher     primary.xulight        #e0e7ff  (tint, dark text)
// ─────────────────────────────────────────────────────────────────────────────
export function getRoleColors(theme) {
  return {
    external_coordinator: theme.palette.info.light,
    coordinator:          theme.palette.info.main,
    project_leader:       theme.palette.secondary.main,
    wp_leader:      theme.palette.primary.main,
    task_leader:    theme.palette.primary.light,
    researcher:     theme.palette.primary.xulight,
  };
}
